import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserRole } from '../models/user-role.type';

export interface ApiUserResponse {
  role: UserRole[];
  activeOrg: string;
  firstName: string;
	lastName: string;
	email: string;
	cellPhone: string;
	country: string;
}

export interface ApiChangeOrganizationResponse {
  activeOrg: string;
}

export interface ApiPutUserResponse {
  firstName: string;
	lastName: string;
	email: string;
	cellPhone: string;
	country: string;
}

export type ApiPutUserRequest = Pick<ApiPutUserResponse, 'firstName' | 'lastName' | 'cellPhone' | 'country'>;

@Injectable({ providedIn: 'root' })
export class ApiUserService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/user';

  constructor(
    private http: HttpClient) {}

  getUserData(): Observable<ApiUserResponse> {
    return this.http.get<ApiUserResponse>(`${this.apiBaseUrl}${this.apiPath}`)
  }

  updateUser(request: ApiPutUserRequest): Observable<ApiPutUserResponse> {
    return this.http.put<ApiPutUserResponse>(`${this.apiBaseUrl}${this.apiPath}`, request);
  }

  changeOrganization(organizationId: string): Observable<ApiChangeOrganizationResponse> {
    return this.http.post<ApiChangeOrganizationResponse>(`${this.apiBaseUrl}${this.apiPath}/change-organization`, { organizationId });
  }
}